import { z } from 'zod';
/**
 * Primitivos reusados por vários módulos.
 *
 * Regra do projeto: o schema zod é a FONTE, e o tipo TypeScript é
 * inferido dele com `z.infer` — nunca o contrário. O mesmo schema
 * valida o corpo da requisição no servidor e o formulário no cliente.
 *
 * Cada módulo acrescenta os seus. Por enquanto, só os primitivos que
 * vários deles vão reusar.
 */
/** UUID de arena, aluno, turma… */
export const zId = z.string().uuid();
/**
 * Telefone brasileiro, normalizado para dígitos.
 *
 * É o campo mais importante do cadastro: é a chave prática de
 * identificação, o número por onde se fala com a pessoa, e o critério de
 * duplicidade na
 * importação de CSV. O protótipo o marca obrigatório em #m-novo-aluno.
 */
export const zTelefone = z
    .string()
    .trim()
    .transform((v) => v.replace(/\D/g, ''))
    .refine((v) => v.length === 10 || v.length === 11, {
    message: 'Telefone deve ter DDD e 8 ou 9 dígitos.',
});
/** Valor monetário em centavos — nunca float para dinheiro. */
export const zCentavos = z.number().int().nonnegative();
/** Data sem hora, no formato ISO. */
export const zDataISO = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Use o formato AAAA-MM-DD.');
/** Paginação por cursor, padrão em todas as listagens. */
export const zPaginacao = z.object({
    cursor: zId.optional(),
    limite: z.number().int().min(1).max(100).default(25),
});
/** Competência de fatura: "2026-09". */
export const zCompetencia = z.string().regex(/^\d{4}-\d{2}$/, 'Use o formato AAAA-MM.');
/**
 * O slug da arena — o `alpha` de "Arena Alpha", que é o endereço dela.
 *
 * Minúsculas, dígitos e hífen, sem começar nem terminar com hífen.
 * Nasceu em `schemas/site.ts` como `zSlugPublico`, do formulário público
 * que foi removido; o slug não era do formulário, é da ARENA, e quem o
 * valida hoje é a criação de arena no painel da plataforma.
 */
export const zSlugDeArena = z
    .string()
    .regex(/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/, 'Endereço de arena inválido.');
//# sourceMappingURL=primitivos.js.map